import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useFetchTrainingContentsApi } from 'api/training_content'
import { TrainingContent, TrainingContentSearchForm } from 'entities/training_content'
import { Pagination } from 'components/shared/pagination'
import { useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { trainingContentColumnInfoList, TrainingContentTableData } from './training_content_table'
import { DisplaySetting, DisplaySettingModal, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { EditTrainingContentForm } from './training_content_form'
import { Flex } from 'components/shared/flex'

type Props = {
    history: H.History
}

const TrainingContentsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<TrainingContentSearchForm>()
    const searchForm = useForm<TrainingContentSearchForm>(query)
    const api = useFetchTrainingContentsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<TrainingContent>()
    const trainingContentDisplaySetting = useDisplaySetting(trainingContentColumnInfoList(searchForm), 'TrainingContent')
    const displaySettings: DisplaySetting[] = [trainingContentDisplaySetting]
    const [selectedTrainingContent, setSelectedTrainingContent] = useState<TrainingContent>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof TrainingContentSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`/ledger/training/contents?${queryParams}`)
        }
    }, [searchForm.object])

    return (
        <>
            <EditTrainingContentForm
                trainingContent={selectedTrainingContent}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ContentHeader
                headerTitle="教育研修・技能評価記録一覧"
                left={
                    <>
                        {/* <CopyTableBuftton /> */}
                        {/* <NewTrainingContentForm
                            onComplete={() => {
                                api.execute()
                            }}
                        /> */}
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<DisplaySettingModal displaySettings={displaySettings} />}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                {/* <ActionTableCell th width={60} /> */}
                                <TableHeads displaySetting={trainingContentDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={trainingContentDisplaySetting.getColumnLength() + 1}>
                            {api.response.results.map((trainingContent: TrainingContent) => {
                                return (
                                    <CheckboxTableRow
                                        key={`trainingContent-${trainingContent.id}`}
                                        item={trainingContent}
                                        multipleCheckForm={multipleCheckForm}
                                    >
                                        {/* <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedTrainingContent(trainingContent)
                                                setShowEdit(true)
                                            }}
                                        /> */}
                                        <TrainingContentTableData trainingContent={trainingContent} displaySetting={trainingContentDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="TrainingContent"
            ></SelectionFixedFooter>
        </>
    )
}

export default withRouter(TrainingContentsPage)
